import {toBoolean, toList, toString} from "../helpers/helpers";

export class SelectableUserModel {
  id: string;
  firstName: string;
  lastName: string;
  displayName: string;
  emailAddress: string;
  roles: string;
  privileges: string[];
  selected: boolean;
  disabled: boolean;
  isCurrentUser: boolean;

  static converter(json?: any): SelectableUserModel {
    return new SelectableUserModel(json);
  }

  constructor(json?: any) {
    json = json || {};
    this.id = toString(json.id);
    this.firstName = toString(json.firstName);
    this.lastName = toString(json.lastName);
    this.displayName = toString(json.displayName);
    this.emailAddress = toString(json.emailAddress);
    this.roles = toString(json.roles);
    this.privileges = toList(toString, json.privileges);
    this.selected = toBoolean(json.selected);
    this.disabled = toBoolean(json.disabled);
    this.isCurrentUser = toBoolean(json.isCurrentUser);
  }
}
